module.exports = __webpack_public_path__ + "static/media/dumbell_orange.2d874dce.svg";